import { SELECTED_CHAIN_KEY } from '../constants'

interface ChainToSelect {
  id: string | number;
  name?: string;
  useQrcode?: boolean;
  usePromoter?: boolean;
}

// Chave própria, nunca o USER_KEY: o authManager reescreve o perfil inteiro a cada
// renovação de token e levaria a escolha junto.
export default (chain: ChainToSelect) => {
  localStorage.setItem(SELECTED_CHAIN_KEY, JSON.stringify({
    chainId: chain.id,
    chainName: chain.name,
    chainUseQrcode: chain.useQrcode,
    chainUsePromoter: chain.usePromoter,
  }))
}
